var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSliderPrev(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 40,
    viewBox: "0 0 42 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#615F67",
    fillRule: "evenodd",
    d: "M42 0L0 20l42 20z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSliderPrev);
export default __webpack_public_path__ + "static/media/slider-prev.cbbe70f4f94127053f9d860ac8997617.svg";
export { ForwardRef as ReactComponent };